import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { usePathFilterTracking } from "../hooks/usePathFilterTracking";
import React, { useEffect, useRef, useState } from "react";
import { getTrackBackground, Range } from "react-range";
export default function PriceRangePicker({ filter, onAfterChange, }) {
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const { trackSegmentCommit } = usePathFilterTracking();
    const values = filter.options.map((o) => o.value);
    const labels = filter.options.map((o) => o.label);
    const maxIndex = values.length - 1;
    const current = selectedState[filter.id];
    const committedIndex = (() => {
        const idx = current ? values.indexOf(current) : maxIndex;
        return idx >= 0 ? idx : maxIndex;
    })();
    const resolvedParamValue = current !== undefined && values.includes(current)
        ? current
        : values[maxIndex];
    /** Avoid duplicate path-filter tracking when onFinalChange runs twice before context re-renders (e.g. touch + mouse). */
    const lastTrackedParamRef = useRef(resolvedParamValue);
    useEffect(() => {
        lastTrackedParamRef.current = resolvedParamValue;
    }, [resolvedParamValue]);
    // Local visual state — updated on every drag step without hitting the API
    const [localIndex, setLocalIndex] = useState(committedIndex);
    // Sync local state when external value changes (e.g. clearAll)
    useEffect(() => {
        setLocalIndex(committedIndex);
    }, [committedIndex]);
    function handleChange(newValues) {
        setLocalIndex(newValues[0]);
    }
    // Only fires on mouse/touch release or key up — triggers the facets request once
    function handleFinalChange(newValues) {
        const idx = newValues[0];
        const nextValue = values[idx];
        const newState = Object.assign(Object.assign({}, selectedState), { [filter.id]: nextValue });
        dispatch({ type: "set_selected", payload: newState });
        if (filter.tracking && lastTrackedParamRef.current !== nextValue) {
            trackSegmentCommit(filter, newState);
            lastTrackedParamRef.current = nextValue;
        }
        onAfterChange === null || onAfterChange === void 0 ? void 0 : onAfterChange(newState);
    }
    return (<div className={"border border-[#A1A2A5] rounded-full p-1 h-10 relative"}>
      <div className={"absolute right-5 text-sm top-1/2 -translate-y-1/2"}>
        {labels[maxIndex]}
      </div>
      <Range label={filter.label} step={1} min={0} max={maxIndex} values={[localIndex]} onChange={handleChange} onFinalChange={handleFinalChange} renderTrack={({ props, children }) => (<div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} className="flex w-full h-full px-[55px]" style={props.style}>
            <div className={"bg-[#DCDDE0] rounded-full h-full w-[110px] absolute left-0 top-1/2 -translate-y-1/2"}></div>
            <div ref={props.ref} className="w-full h-full self-center" style={{
                background: getTrackBackground({
                    values: [localIndex],
                    colors: ["#DCDDE0", "#ffffff"],
                    min: 0,
                    max: maxIndex,
                }),
            }}>
              {children}
            </div>
          </div>)} renderThumb={({ props }) => (<div {...props} key={props.key} className="w-[110px] h-8 rounded-full bg-[#1C2022] text-white text-sm whitespace-nowrap flex items-center justify-center" style={props.style}>
            Rata {labels[localIndex]}
          </div>)}/>
    </div>);
}
